<!--
    <footer-bar theme="theme-dark" rate="'18'">
        <template v-slot:logo>
            <img src="liber.png" alt="">
            <img src="bandai.png" alt="">
            <img src="gungho.png" alt="" style="height:40px">
            <img src="cygame.png" alt="">
        </template>
        <template v-slot:cpr>
            <li>©Liber Entertainment Inc. All Right Reserved.</li>
            <li>©BANDAI NAMCO Entertainment Inc.</li>
            <li>© CAPCOM CO., LTD. ALL RIGHTS RESERVED.</li>
            <li>© GungHo Online Entertainment, Inc. All Rights Reserved.</li>
            <li>© Cygames, Inc.</li>
        </template>
    </footer-bar>
-->

<template>
  <div class="-Footer footer-bar" :class="theme" :style="{minWidth: '1300px'}">
    <div class="footer-inner footer-inner">
      <div class="footer-logo footer-logo" :class="{'has-other': hasOther}">
        <svg class="komoe-logo" viewBox="0 0 595.276 841.89">
          <path
            d="M-825.101,338.206c-24.063-14.396-53.03-21.598-86.902-21.598c-33.88,0-62.842,7.289-86.887,21.852c-24.053,14.57-42.252,33.794-54.605,57.678c-12.362,23.885-18.53,49.723-18.52,77.497c0.01,27.783,6.284,53.867,18.83,78.26c12.538,24.392,30.926,44.132,55.157,59.203c24.222,15.071,52.935,22.614,86.14,22.614c33.197,0,61.904-7.543,86.124-22.614c24.211-15.071,42.585-34.811,55.113-59.203c12.52-24.393,18.783-50.476,18.773-78.26c-0.01-28.116-6.205-54.121-18.576-78.005C-782.832,371.746-801.046,352.61-825.101,338.206z M-869.502,529.416c-11.14,12.519-25.28,18.771-42.419,18.771c-16.801,0-30.857-6.252-42.176-18.771c-11.318-12.512-16.982-31.114-16.991-55.799c-0.009-23.994,5.722-41.914,17.208-53.742c11.478-11.828,25.449-17.743,41.905-17.743c16.456,0,30.423,5.834,41.918,17.486c11.487,11.659,17.238,29.659,17.247,53.999C-852.799,498.302-858.369,516.905-869.502,529.416z M25.123,338.206c-24.063-14.396-53.03-21.598-86.902-21.598c-33.879,0-62.842,7.289-86.886,21.852c-24.053,14.57-42.252,33.794-54.605,57.678c-12.362,23.885-18.53,49.723-18.52,77.497c0.01,27.783,6.284,53.867,18.83,78.26c12.538,24.392,30.926,44.132,55.157,59.203c24.222,15.071,52.935,22.614,86.14,22.614c33.196,0,61.904-7.543,86.124-22.614c24.211-15.071,42.585-34.811,55.113-59.203c12.52-24.393,18.783-50.476,18.773-78.26c-0.01-28.116-6.205-54.121-18.576-78.005C67.392,371.746,49.179,352.61,25.123,338.206z M-19.277,529.416c-11.14,12.519-25.28,18.771-42.419,18.771c-16.802,0-30.857-6.252-42.176-18.771c-11.318-12.512-16.982-31.114-16.991-55.799c-0.008-23.994,5.722-41.914,17.208-53.742c11.478-11.828,25.449-17.743,41.906-17.743c16.456,0,30.423,5.834,41.918,17.486c11.487,11.659,17.238,29.659,17.247,53.999C-2.575,498.302-8.145,516.905-19.277,529.416z M1633.381,343.797c-19.491-18.12-43.965-27.188-73.438-27.188c-21.009,0-41.334,4.065-60.974,12.197c-19.648,8.131-34.215,18.128-43.691,29.982h-0.508c-7.119-12.53-18.389-22.614-33.803-30.237c-15.422-7.623-32.955-11.434-52.598-11.434c-31.847,0-64.221,13.071-93.688,31.698v-0.076l-96.637-31.077l-0.65,315.904h101.364l-0.079-217.862c18.289-11.855,32.464-17.786,47.034-17.786c13.212,0,23.544,4.748,31.002,14.229c7.451,9.489,11.191,31.36,11.197,47.622l0.048,131.303l100.118,31.101l-0.074-201.895c15.24-14.229,30.815-21.344,46.743-21.344c13.212,0,24.218,4.574,33.035,13.721c8.809,9.147,13.219,20.16,13.224,33.032l0.068,187.879h63.519h10.671h27.44l-0.074-203.125C1662.617,390.803,1652.864,361.924,1633.381,343.797z M-274.039,343.797c-19.491-18.12-43.965-27.188-73.438-27.188c-21.009,0-41.334,4.065-60.974,12.197c-19.648,8.131-34.214,18.128-43.69,29.982h-0.508c-7.119-12.53-18.389-22.614-33.804-30.237c-15.422-7.623-32.955-11.434-52.598-11.434c-31.847,0-64.221,13.071-93.688,31.698v-0.076l-96.637-31.077l-0.65,315.904h101.364l-0.079-217.862c18.289-11.855,32.464-17.786,47.034-17.786c13.212,0,23.543,4.748,31.002,14.229c7.451,9.489,11.191,31.36,11.197,47.622l0.048,131.303l100.118,31.101l-0.074-201.895c15.24-14.229,30.815-21.344,46.743-21.344c13.212,0,24.218,4.574,33.035,13.721c8.809,9.147,13.219,20.16,13.224,33.032l0.069,187.879h63.519h10.672h27.44l-0.074-203.125C-244.803,390.803-254.556,361.924-274.039,343.797z M431.195,474.144c-0.011-29.474-5.61-56.066-16.798-79.784c-11.188-23.71-28.393-42.6-51.598-56.662c-23.213-14.055-52.093-21.09-86.648-21.09c-33.879,0-62.5,6.948-85.871,20.835c-23.37,13.895-40.728,32.778-52.065,56.662c-11.346,23.884-17.005,50.905-16.994,81.055c0.011,30.157,6.119,57.258,18.323,81.309c12.205,24.059,30.33,42.941,54.393,56.662c24.055,13.721,53.363,20.581,87.918,20.581c37.262,0,67.407-6.948,90.443-20.835c20.198-12.187,37.887-32.02,51.569-58.015c-32.061-8.666-87.107-26.293-87.107-26.293c-6.437,7.456-14.626,15.791-22.414,19.007c-7.796,3.224-18.467,4.828-32.012,4.828c-11.521,0-21.851-1.858-31-5.59c-9.148-3.724-16.184-8.639-21.094-14.737c-4.917-6.098-7.373-12.196-7.375-18.294h208.343L431.195,474.144z M222.838,437.555c-0.002-5.415,1.775-11.18,5.329-17.278c3.555-6.098,9.397-11.347,17.526-15.754c8.129-4.399,18.291-6.606,30.487-6.606c11.854,0,21.852,2.374,29.984,7.115c8.132,4.748,14.057,10.251,17.791,16.516c3.726,6.273,5.594,11.609,5.595,16.007H222.838z M1878.906,547.576c-7.796,3.224-18.467,4.828-32.012,4.828c-11.521,0-21.851-1.858-31-5.59c-9.148-3.724-16.184-8.639-21.094-14.737c-4.917-6.098-7.373-12.196-7.375-18.294h208.343l-0.014-39.638c-0.011-29.474-5.61-56.066-16.798-79.784c-11.188-23.71-28.393-42.6-51.598-56.662c-23.213-14.055-52.093-21.09-86.648-21.09c-33.879,0-62.5,6.948-85.871,20.835c-23.37,13.895-40.728,32.778-52.065,56.662c-11.346,23.884-17.005,50.905-16.994,81.055c0.011,30.157,6.119,57.258,18.323,81.309c12.205,24.059,30.33,42.941,54.393,56.662c24.055,13.721,53.364,20.581,87.918,20.581c37.262,0,67.407-6.948,90.443-20.835c20.198-12.187,37.887-32.02,51.569-58.015c-32.061-8.666-87.107-26.293-87.107-26.293C1894.883,536.026,1886.694,544.361,1878.906,547.576z M1792.727,420.277c3.555-6.098,9.397-11.347,17.526-15.754c8.129-4.399,18.291-6.606,30.487-6.606c11.854,0,21.852,2.374,29.984,7.115c8.132,4.748,14.057,10.251,17.791,16.516c3.726,6.273,5.7,12.358,5.701,16.757h-106.712C1787.502,432.89,1789.173,426.376,1792.727,420.277z M1156.408,631.686l-0.031-84.565c0-0.002,0-0.005,0-0.007l-0.014-37.11h-0.005l-0.029-79.479c-0.013-36.247-12.919-64.37-36.81-84.188c-23.89-19.819-58.536-29.728-103.928-29.728c-73.176,0-130.173,21.296-130.173,21.296l0.201,78.455c0,0,59.102-18.442,124.92-18.442c14.228,0,24.9,2.628,32.017,7.877c7.116,5.256,10.842,11.434,11.186,18.548l0.001,1.017c-68.432,5.765-117.718,19.057-147.858,39.892c-30.148,20.835-45.208,49.214-45.195,85.12c0.007,17.961,5.26,33.207,15.769,45.737c10.501,12.53,23.804,21.931,39.9,28.204c16.088,6.265,32.438,9.401,49.04,9.401c18.294,0,35.824-2.541,52.591-7.622c14.646-4.439,27.025-10.302,37.149-17.583l0.009,25.204h73.771c0.034,0,0.07,0.002,0.104,0.002c0.065,0,0.131-0.002,0.196-0.002h27.188L1156.408,631.686C1156.408,631.686,1156.408,631.686,1156.408,631.686z M962.316,537.667c-0.009-24.97,44.706-30.999,91.456-30.999l0.012,31.532C1005.009,559.883,962.322,554.572,962.316,537.667z M641.301,393.857l-0.555,76.002h96.759l-0.375,62.207h-69.087c-1.641,0.074-3.29,0.117-4.949,0.117c-59.951,0-108.568-48.599-108.59-108.55c-0.021-57.089,44.034-103.883,100.009-108.22H812.63l-0.874-100.465H662.964l0-0.034c-0.033,0-0.066-0.001-0.099-0.001c-0.929,0-1.852,0.023-2.777,0.035h-0.52l-0.001,0.007c-113.664,1.765-205.232,94.445-205.19,208.537c0.042,115.195,93.454,208.579,208.641,208.579c0.656,0,1.306-0.026,1.961-0.031l0.005,0.323h173.255l-0.44-238.505H641.301z M-1018.927,254.125l-119.788-37.252L-1302.39,358.72l-0.041-112.673l-101.291-31.203l0.324,418.456h101.259l-0.197-132.787l27.876-23.997l135.931,156.897h124.779l-189.383-218.287L-1018.927,254.125z"
          />
        </svg>
        <!-- 插入额外logo图片 -->
        <slot name="logo"></slot>
        <img
          class="game-rate"
          :class="`level${rate}`"
          v-if="rate"
        />
      </div>
      <div class="footer-bar footer-bar">
        <ul class="footer-copyright footer-copyright">
          <li>{{$t('footer.cpr', {fullYear: new Date().getFullYear()})}}</li>
          <slot name="cpr"></slot>
        </ul>
        <div class="footer-links footer-links">
          <router-link :to="{name: 'about'}">
            <a ga-data="106001">{{$t('footer.about')}}</a>
          </router-link>
          <span class="footer-vr footer-vr"></span>
          <router-link :to="{name: 'terms'}">
            <a ga-data="106003">{{$t('footer.rule')}}</a>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "footer-pc",
  props: ["theme", "rate"],
  data() {
    return {
      hasOther: false
    };
  },
  mounted() {
    const imgSum = document
      .getElementsByClassName("footer-logo")[0]
      .getElementsByTagName("img").length;
    if (this.rate) {
      if (imgSum > 1) {
        this.hasOther = true;
      } else {
        this.hasOther = false;
      }
    } else {
      if (imgSum > 0) {
        this.hasOther = true;
      } else {
        this.hasOther = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.-Footer {
  font-size: 14px;
  color: #999;
  background-color: #f2f2f2;
  a {
    color: #999;
    text-decoration: none;
    &:hover {
      color: #2da2d4;
    }
  }
  .footer-inner {
    padding: 40px 0;
  }
  .footer-logo {
    width: 1170px;
    margin: 0 auto;
    position: relative;
    img {
      height: 30px;
      vertical-align: middle;
    }
    img {
      margin-left: 30px;
    }
    .komoe-logo {
      display: inline-block;
      vertical-align: middle;
      width: 164px;
      height: 40px;
      fill: #231815;
    }
    img.game-rate {
      width: 50px;
      height: 50px;
      // 靠右，垂直居中
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -25px;
      background-repeat: no-repeat;
      background-size: contain;
      &.level0 {
        background-image: url('./imgs/0.png');
      }
      &.level6 {
        background-image: url('./imgs/6.png');
      }
      &.level12 {
        background-image: url('./imgs/12.png');
      }
      &.level15 {
        background-image: url('./imgs/15.png');
      }
      &.level18 {
        background-image: url('./imgs/18.png');
      }
    }
  }
  .footer-logo.has-other {
    .komoe-logo {
      height: 16px;
    }
  }
  .footer-bar {
    display: table;
    border-collapse: collapse;
    overflow: hidden;
    // 为抵消内部 li 两边 10px margin ，故让总宽度多出 20px
    width: 1190px;
    margin: 30px auto 0;
    line-height: 2;
  }
  .footer-copyright {
    display: table-cell;
    margin: 0;
    padding: 0;
    li {
      display: inline-block;
      margin: 0 10px;
    }
  }
  .footer-links {
    display: table-cell;
    white-space: nowrap;
    vertical-align: bottom;
    padding-left: 80px;
    text-align: right;
    padding-right: 10px;
  }
  .footer-vr {
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    height: 1em;
    background-color: #999;
    margin: 0 1em;
  }
}

.-Footer.theme-dark {
  background-color: #000;
  .footer-logo {
    .komoe-logo {
      fill: white;
    }
  }
}
</style>>